import React from 'react'
import { GET_ENUMS } from '../../constants/modals'
import { useGetPopupState } from '../../hooks/useGetPopupState'
import { AuthModule } from '../../modules/AuthModule'
import { UserProfile } from '../../modules/UserProfile'

const popups = {
  [GET_ENUMS.popup.signin]: AuthModule,
  [GET_ENUMS.popup.profileInfo]: UserProfile,
}

export const GetParameterPopup = () => {
  const { mountedPopup, isOpened } = useGetPopupState()

  if (!mountedPopup) {
    return null
  }

  const Component = popups[mountedPopup]

  if (!Component) {
    return null
  }
  return <Component isOpened={isOpened} />
}
